import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import './JsonRenderer.scss';

const JsonRenderer = ({ json, title, variant = 'card' }) => {
  return (
    <div className={`json-renderer json-renderer--${variant}`}>
      <h3 className="json-renderer__title">{title}</h3>
      {json && (
        <div className="json-renderer__content">
          <SyntaxHighlighter language="json" wrapLongLines>
            {JSON.stringify(json, null, 2)}
          </SyntaxHighlighter>
        </div>
      )}
    </div>
  );
};

export default JsonRenderer;
